module.exports = __webpack_public_path__ + "3a3af54b0194142d6f7a4d5186181121.png";